<script>
    import Product from "./Shop/Product.svelte";

    export let SERVER;

    const fetchProducts = async () => {
		const response = await fetch(SERVER + '/api/products/featured');
        return await response.json();
	};

</script>

<section id="shop" class="container-fluid">
    <div class="d-flex align-items-center justify-content-center m-3">
        <h2>SHOP</h2>
    </div>

    <div class="row g-5">
        {#await fetchProducts()}
            <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        {:then responseJson}
            {#each responseJson.data as product}
                <Product SERVER={SERVER} product={product}/>
            {/each}
        {:catch error}
            <p>An error occurred!</p>
        {/await}
    </div>

</section>

<style>
    #shop {

	}
</style>
